/* 🤖 this file was generated by svg-to-ts */
export const matIconViewHeadline: {
  name: 'view-headline';
  data: string;
} = {
  name: 'view-headline',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"/></svg>`
};
